import root from './internals/root.js';
import isNumber from './isNumber.js';

function isNaN(value) {
    return isNumber(value) && root.isNaN(value);
}

export { isNaN as default };
